import { observable, action, makeObservable } from 'mobx';

export abstract class Menu {
    @observable public isOpen = false;
    @observable public disableOpen = false;

    constructor() {
        makeObservable(this);
    }

    @action.bound
    public toggleIsLeftMenuOpen(): void {
        this.isOpen = !this.isOpen;
    }
}
